import type { ModelId } from '../providers/types';

interface Props {
  value: ModelId;
  disabled?: boolean;
  onChange: (m: ModelId) => void;
}

export function ModelSelector({ value, disabled, onChange }: Props) {
  return (
    <label style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
      モデル:
      <select
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value as ModelId)}
        style={{ padding: '4px 8px' }}
      >
        <option value="gemini-2.5-flash">Gemini 2.5 Flash</option>
        <option value="gpt-4o-audio-preview">GPT-4o Audio</option>
      </select>
    </label>
  );
}
